export default __webpack_public_path__ + "static/media/Correspondance.7a5a39c2.woff2";